import React from 'react';
import {Link} from 'react-router-dom';
import logo_fi_lvv from '../images/logo_fi_lvv.svg';
import logo_sv_lvv from '../images/logo_sv_lvv.svg';
import '../styles/header.css';
import {useIntl} from 'react-intl';
import LanguageSwitch from './NewLanguageSwitch';

const NewHeader = props => {
  const intl = useIntl();

  const {headingLevel, title} = props;
  const Title = headingLevel;

  return (
    <header className="header_new">
      <Title style={{display: 'none'}}>{title}</Title>
      <div className="header__nav">
        <div>
          <Link to="/">
            <img
              className={intl.locale === 'fi' ? 'logo__fi' : 'logo__sv'}
              alt={'lvv-placeholder'}
              src={intl.locale === 'fi' ? logo_fi_lvv : logo_sv_lvv}
            />
          </Link>
        </div>
        <LanguageSwitch language={props.language} onLanguageChange={props.onLanguageChange} />
      </div>
    </header>
  );
};

export default NewHeader;
